/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FinalizeGenerationProcedureDto,
  GenerateProcedureDto,
  ProcedureGenerationOutputDto,
  ProcedureListResponseDto,
  RenameProcedureDto,
  RenameProcedureFileDto,
  ToggleProcedureVisibilityDto,
  UpdateProcedureFeedbackDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FinalizeGenerationProcedureDtoFromJSON,
    FinalizeGenerationProcedureDtoToJSON,
    GenerateProcedureDtoFromJSON,
    GenerateProcedureDtoToJSON,
    ProcedureGenerationOutputDtoFromJSON,
    ProcedureGenerationOutputDtoToJSON,
    ProcedureListResponseDtoFromJSON,
    ProcedureListResponseDtoToJSON,
    RenameProcedureDtoFromJSON,
    RenameProcedureDtoToJSON,
    RenameProcedureFileDtoFromJSON,
    RenameProcedureFileDtoToJSON,
    ToggleProcedureVisibilityDtoFromJSON,
    ToggleProcedureVisibilityDtoToJSON,
    UpdateProcedureFeedbackDtoFromJSON,
    UpdateProcedureFeedbackDtoToJSON,
} from '../models/index';

export interface DeleteProcedureRequest {
    procedureId: string;
}

export interface FinalizeGenerationProcedureRequest {
    finalizeGenerationProcedureDto: FinalizeGenerationProcedureDto;
}

export interface GenerateProcedureRequest {
    generateProcedureDto: GenerateProcedureDto;
}

export interface GetProcedureByPatientIdRequest {
    patientId: string;
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    dateRange?: GetProcedureByPatientIdDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: string;
    sortOrder?: GetProcedureByPatientIdSortOrderEnum;
}

export interface GetProcedureGeneratedByProviderRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    dateRange?: GetProcedureGeneratedByProviderDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: string;
    sortOrder?: GetProcedureGeneratedByProviderSortOrderEnum;
}

export interface GetProcedureGenerationOutputRequest {
    procedureId: string;
}

export interface GetProceduresForPatientRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    dateRange?: GetProceduresForPatientDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: string;
    sortOrder?: GetProceduresForPatientSortOrderEnum;
}

export interface RenameProcedureRequest {
    procedureId: string;
    renameProcedureDto: RenameProcedureDto;
}

export interface RenameProcedureFileRequest {
    procedureId: string;
    renameProcedureFileDto: RenameProcedureFileDto;
}

export interface ToggleProcedureVisibilityRequest {
    procedureId: string;
    toggleProcedureVisibilityDto: ToggleProcedureVisibilityDto;
}

export interface UpdateProcedureFeedbackRequest {
    procedureId: string;
    updateProcedureFeedbackDto: UpdateProcedureFeedbackDto;
}

/**
 * 
 */
export class ProcedureApi extends runtime.BaseAPI {

    /**
     * Deletes a procedure by ID. Only the provider who created it can delete it. The patient will no longer see this procedure.
     * Delete a procedure (Doctor only)
     */
    async deleteProcedureRaw(requestParameters: DeleteProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['procedureId'] == null) {
            throw new runtime.RequiredError(
                'procedureId',
                'Required parameter "procedureId" was null or undefined when calling deleteProcedure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/{procedureId}`.replace(`{${"procedureId"}}`, encodeURIComponent(String(requestParameters['procedureId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a procedure by ID. Only the provider who created it can delete it. The patient will no longer see this procedure.
     * Delete a procedure (Doctor only)
     */
    async deleteProcedure(requestParameters: DeleteProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProcedureRaw(requestParameters, initOverrides);
    }

    /**
     * Finalizes the procedure generation process by triggering the PDF generation process.
     * Finalize procedure generation
     */
    async finalizeGenerationProcedureRaw(requestParameters: FinalizeGenerationProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['finalizeGenerationProcedureDto'] == null) {
            throw new runtime.RequiredError(
                'finalizeGenerationProcedureDto',
                'Required parameter "finalizeGenerationProcedureDto" was null or undefined when calling finalizeGenerationProcedure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/finalize-generation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinalizeGenerationProcedureDtoToJSON(requestParameters['finalizeGenerationProcedureDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finalizes the procedure generation process by triggering the PDF generation process.
     * Finalize procedure generation
     */
    async finalizeGenerationProcedure(requestParameters: FinalizeGenerationProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finalizeGenerationProcedureRaw(requestParameters, initOverrides);
    }

    /**
     * Generates a procedure document for a patient. Accepts procedure details and additional comments as input to feed into Gemini generation.
     * Generate procedure document (Doctor only)
     */
    async generateProcedureRaw(requestParameters: GenerateProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['generateProcedureDto'] == null) {
            throw new runtime.RequiredError(
                'generateProcedureDto',
                'Required parameter "generateProcedureDto" was null or undefined when calling generateProcedure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/generation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateProcedureDtoToJSON(requestParameters['generateProcedureDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a procedure document for a patient. Accepts procedure details and additional comments as input to feed into Gemini generation.
     * Generate procedure document (Doctor only)
     */
    async generateProcedure(requestParameters: GenerateProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generateProcedureRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves procedures by patient ID
     * Get procedures by patient ID
     */
    async getProcedureByPatientIdRaw(requestParameters: GetProcedureByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcedureListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getProcedureByPatientId().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getProcedureByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcedureListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves procedures by patient ID
     * Get procedures by patient ID
     */
    async getProcedureByPatientId(requestParameters: GetProcedureByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcedureListResponseDto> {
        const response = await this.getProcedureByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves procedures generated by the authenticated provider
     * Get procedures generated by provider
     */
    async getProcedureGeneratedByProviderRaw(requestParameters: GetProcedureGeneratedByProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcedureListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getProcedureGeneratedByProvider().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/generated-by-provider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcedureListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves procedures generated by the authenticated provider
     * Get procedures generated by provider
     */
    async getProcedureGeneratedByProvider(requestParameters: GetProcedureGeneratedByProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcedureListResponseDto> {
        const response = await this.getProcedureGeneratedByProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all files generated for a procedure, including the procedure file path, URL, and token usage
     * Get procedure generation output
     */
    async getProcedureGenerationOutputRaw(requestParameters: GetProcedureGenerationOutputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcedureGenerationOutputDto>> {
        if (requestParameters['procedureId'] == null) {
            throw new runtime.RequiredError(
                'procedureId',
                'Required parameter "procedureId" was null or undefined when calling getProcedureGenerationOutput().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/generation-output/{procedureId}`.replace(`{${"procedureId"}}`, encodeURIComponent(String(requestParameters['procedureId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcedureGenerationOutputDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all files generated for a procedure, including the procedure file path, URL, and token usage
     * Get procedure generation output
     */
    async getProcedureGenerationOutput(requestParameters: GetProcedureGenerationOutputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcedureGenerationOutputDto> {
        const response = await this.getProcedureGenerationOutputRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the authenticated patient\'s own procedures. Patient only endpoint.
     * Get procedures for patient
     */
    async getProceduresForPatientRaw(requestParameters: GetProceduresForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcedureListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getProceduresForPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcedureListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the authenticated patient\'s own procedures. Patient only endpoint.
     * Get procedures for patient
     */
    async getProceduresForPatient(requestParameters: GetProceduresForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcedureListResponseDto> {
        const response = await this.getProceduresForPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets a custom display name for a procedure. The patient will see this name.
     * Rename a procedure (Doctor only)
     */
    async renameProcedureRaw(requestParameters: RenameProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['procedureId'] == null) {
            throw new runtime.RequiredError(
                'procedureId',
                'Required parameter "procedureId" was null or undefined when calling renameProcedure().'
            );
        }

        if (requestParameters['renameProcedureDto'] == null) {
            throw new runtime.RequiredError(
                'renameProcedureDto',
                'Required parameter "renameProcedureDto" was null or undefined when calling renameProcedure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/{procedureId}/rename`.replace(`{${"procedureId"}}`, encodeURIComponent(String(requestParameters['procedureId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameProcedureDtoToJSON(requestParameters['renameProcedureDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a custom display name for a procedure. The patient will see this name.
     * Rename a procedure (Doctor only)
     */
    async renameProcedure(requestParameters: RenameProcedureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameProcedureRaw(requestParameters, initOverrides);
    }

    /**
     * Sets a custom display name for an individual file (txt, pdf) within a procedure.
     * Rename a file within a procedure
     */
    async renameProcedureFileRaw(requestParameters: RenameProcedureFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['procedureId'] == null) {
            throw new runtime.RequiredError(
                'procedureId',
                'Required parameter "procedureId" was null or undefined when calling renameProcedureFile().'
            );
        }

        if (requestParameters['renameProcedureFileDto'] == null) {
            throw new runtime.RequiredError(
                'renameProcedureFileDto',
                'Required parameter "renameProcedureFileDto" was null or undefined when calling renameProcedureFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/{procedureId}/rename-file`.replace(`{${"procedureId"}}`, encodeURIComponent(String(requestParameters['procedureId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameProcedureFileDtoToJSON(requestParameters['renameProcedureFileDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a custom display name for an individual file (txt, pdf) within a procedure.
     * Rename a file within a procedure
     */
    async renameProcedureFile(requestParameters: RenameProcedureFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameProcedureFileRaw(requestParameters, initOverrides);
    }

    /**
     * Allows the provider to show or hide a procedure from the patient\'s view. When isHiddenFromPatient is true the patient cannot see this record.
     * Toggle procedure visibility for patient (Doctor only)
     */
    async toggleProcedureVisibilityRaw(requestParameters: ToggleProcedureVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcedureGenerationOutputDto>> {
        if (requestParameters['procedureId'] == null) {
            throw new runtime.RequiredError(
                'procedureId',
                'Required parameter "procedureId" was null or undefined when calling toggleProcedureVisibility().'
            );
        }

        if (requestParameters['toggleProcedureVisibilityDto'] == null) {
            throw new runtime.RequiredError(
                'toggleProcedureVisibilityDto',
                'Required parameter "toggleProcedureVisibilityDto" was null or undefined when calling toggleProcedureVisibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/{procedureId}/visibility`.replace(`{${"procedureId"}}`, encodeURIComponent(String(requestParameters['procedureId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ToggleProcedureVisibilityDtoToJSON(requestParameters['toggleProcedureVisibilityDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcedureGenerationOutputDtoFromJSON(jsonValue));
    }

    /**
     * Allows the provider to show or hide a procedure from the patient\'s view. When isHiddenFromPatient is true the patient cannot see this record.
     * Toggle procedure visibility for patient (Doctor only)
     */
    async toggleProcedureVisibility(requestParameters: ToggleProcedureVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcedureGenerationOutputDto> {
        const response = await this.toggleProcedureVisibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the feedback field for a procedure. Allowed for the generating provider.
     * Update procedure feedback
     */
    async updateProcedureFeedbackRaw(requestParameters: UpdateProcedureFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcedureGenerationOutputDto>> {
        if (requestParameters['procedureId'] == null) {
            throw new runtime.RequiredError(
                'procedureId',
                'Required parameter "procedureId" was null or undefined when calling updateProcedureFeedback().'
            );
        }

        if (requestParameters['updateProcedureFeedbackDto'] == null) {
            throw new runtime.RequiredError(
                'updateProcedureFeedbackDto',
                'Required parameter "updateProcedureFeedbackDto" was null or undefined when calling updateProcedureFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/procedure/{procedureId}/feedback`.replace(`{${"procedureId"}}`, encodeURIComponent(String(requestParameters['procedureId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProcedureFeedbackDtoToJSON(requestParameters['updateProcedureFeedbackDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcedureGenerationOutputDtoFromJSON(jsonValue));
    }

    /**
     * Updates the feedback field for a procedure. Allowed for the generating provider.
     * Update procedure feedback
     */
    async updateProcedureFeedback(requestParameters: UpdateProcedureFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcedureGenerationOutputDto> {
        const response = await this.updateProcedureFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetProcedureByPatientIdDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetProcedureByPatientIdDateRangeEnum = typeof GetProcedureByPatientIdDateRangeEnum[keyof typeof GetProcedureByPatientIdDateRangeEnum];
/**
 * @export
 */
export const GetProcedureByPatientIdSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetProcedureByPatientIdSortOrderEnum = typeof GetProcedureByPatientIdSortOrderEnum[keyof typeof GetProcedureByPatientIdSortOrderEnum];
/**
 * @export
 */
export const GetProcedureGeneratedByProviderDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetProcedureGeneratedByProviderDateRangeEnum = typeof GetProcedureGeneratedByProviderDateRangeEnum[keyof typeof GetProcedureGeneratedByProviderDateRangeEnum];
/**
 * @export
 */
export const GetProcedureGeneratedByProviderSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetProcedureGeneratedByProviderSortOrderEnum = typeof GetProcedureGeneratedByProviderSortOrderEnum[keyof typeof GetProcedureGeneratedByProviderSortOrderEnum];
/**
 * @export
 */
export const GetProceduresForPatientDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetProceduresForPatientDateRangeEnum = typeof GetProceduresForPatientDateRangeEnum[keyof typeof GetProceduresForPatientDateRangeEnum];
/**
 * @export
 */
export const GetProceduresForPatientSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetProceduresForPatientSortOrderEnum = typeof GetProceduresForPatientSortOrderEnum[keyof typeof GetProceduresForPatientSortOrderEnum];
